import React from 'react'
import { Article } from '../../components'
import { blog01, blog02, blog03, blog04, blog05 } from './imports'
import './blog.css'

const Blog = () => {
  return (
    <div className='omit__blog section__padding' id='blog'>
      <div className='omit__blog-heading'>
        <h1 className='gradient__text'>
          A lot is happening, We are blogging about it.
        </h1>
      </div>
      <div className='omit__blog-container'>
        <div className='omit__blog-container_groupA'>
          <Article
            imgUrl={blog01}
            date={'Jan 18, 2023'}
            title={
              'Google kills Glass Enterprise, but big tech`s AR dreams live on'
            }
          />
        </div>
        <div className='omit__blog-container_groupB'>
          <Article
            imgUrl={blog02}
            date={'Dec 4, 2022'}
            title={'ChatGPT gets support for a dozen application plug-ins'}
          />
          <Article
            imgUrl={blog03}
            date={'Nov 20, 2022'}
            title={
              'Adobe enters the age of generative AI with creative and enterprise apps'
            }
          />
          <Article
            imgUrl={blog04}
            date={'Oct 10, 2022'}
            title={
              'Will Apple switch the iPhone to eSIM-only everywhere by ’24?'
            }
          />
          <Article
            imgUrl={blog05}
            date={'Sep 26, 2022'}
            title={'GPT-3 and Open  AI is the future. Let us exlore how it is?'}
          />
        </div>
      </div>
    </div>
  )
}

export default Blog
